import React from 'react'


export const Logo = () => {
  return (
    <div className="ContainerLogo">
      <img className="LogoArt" src="https://res.cloudinary.com/dwj1w03r9/image/upload/v1678999625/artViews/Black_Blush_Elegant_Luxury_Name_Initial_Typography_Photography_Logo_1_czjzbt.png" alt="" />
    </div>
  )
}